import { render, staticRenderFns } from "./addAVMemberModal.vue?vue&type=template&id=a1552af4"
import script from "./addAVMemberModal.vue?vue&type=script&lang=js"
export * from "./addAVMemberModal.vue?vue&type=script&lang=js"
import style0 from "./addAVMemberModal.vue?vue&type=style&index=0&id=a1552af4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports